import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeDemoOptimizations } from './utils/demoOptimization'
import { initSentry } from './lib/sentry'

// Initialize Sentry error monitoring before app render
initSentry();

// Initialize performance optimizations before app render
initializeDemoOptimizations();

createRoot(document.getElementById("root")!).render(<App />);
